module.exports = __webpack_public_path__ + "prod/1.42.2/img/wechata.038a8f4b.svg";